import defaultsDeep from "lodash/defaultsDeep";
import {
	checkIfSDPPages,
	mapFicheProduitStoreToTag,
	mapPageStoreToTag,
	mapPrePackageStoreToTag,
	mapQuoteStoreToTag,
	mapUserStoreToTag,
} from "app/utils/analytics-store-mapper";

/**
 * Tronc commun du dataLayer : les données présentes sur tous les évènements.
 *
 * We can have product, prePackage and quote data here even if it is not relevant depending on the
 * pages. To simplify, we can always put thoses data in every event. Data team will pick up the
 * right data depending on the event name.
 */
export const buildCommonData = ({ state, pathname, search }) => ({
	merchCode: state.merchandising?.current?.code,
	brand: state.brand.code,
	isSdp: checkIfSDPPages(pathname),
	isSmartDP: state.quotation.isSmartDP,
	shop: state.shop,
	currency: state?.currency,
	env: state.envVars?.ENVIRONMENT,
	page: mapPageStoreToTag({ pathname, search, state }),
	partnerCode: state.partner?.code,
	hotjarSessionId: window._hjSettings?.hjid, // id de session de recording hotjar
	user: mapUserStoreToTag(state),
	product: mapFicheProduitStoreToTag(state.ficheProduit),
	prePackage: mapPrePackageStoreToTag(state),
	quote: mapQuoteStoreToTag(state),
});

/**
 * Fusionne le payload d'un évènement dans le tronc commun.
 *
 * Une propriété objet du payload (`quote`, `product`, `page`…) ENRICHIT celle du tronc commun
 * au lieu de la remplacer : c'est ce qui permet à un call site de n'ajouter qu'un champ, par
 * exemple `quote: { quotationReloadUrl }`, sans perdre le quote issu du store.
 * Les valeurs du payload restent prioritaires sur celles du tronc commun.
 *
 * La cible `{}` garantit que ni `payload` ni `commonData` ne sont mutés — indispensable pour que
 * `eventProperties` puisse rester le payload brut.
 *
 * À savoir : deux tableaux portant la même clé fusionnent par index
 * (`["a"]` + `["x", "y"]` => `["a", "y"]`).
 */
export const buildTagData = ({ eventName, payload = {}, commonData }) =>
	defaultsDeep({}, { event: eventName, ...payload }, commonData);
